import { Lang } from '../../Lang';
import { FormGroup2, Input2, InputType2, LangTextV2, ModalDialog2, ModalDialogType2, Select2, Switch2 } from 'bambooo';
/**
 * Edit modal for one organization_external_tour_source row.
 *
 * Fields are kept text-based because providers other than FareHarbor
 * may want different shapes — `item_pks` is a comma-separated string
 * in the UI and the page splits/joins on save.
 *
 * `provider` is a Select today restricted to the providers we have
 * a class for; widening it later is a matter of adding entries
 * (and the corresponding backend provider class).
 */
export class ExternalTourSourceEditModal extends ModalDialog2 {
    constructor() {
        super({ modalType: ModalDialogType2.large });
        this._id = null;
        const body = jQuery('<div class="card-body"/>').appendTo(this.getBody());
        const groupOrg = new FormGroup2({ label: new LangTextV2({ text: 'Organization' }) });
        groupOrg.appendTo(body);
        this._selectOrganization = new Select2({});
        this._selectOrganization.appendTo(groupOrg);
        const groupProvider = new FormGroup2({ label: new LangTextV2({ text: 'Provider' }) });
        groupProvider.appendTo(body);
        this._selectProvider = new Select2({});
        this._selectProvider.appendTo(groupProvider);
        this._selectProvider.setValues([{ key: 'fareharbor', value: 'FareHarbor' }]);
        this._selectProvider.setSelectedValue('fareharbor');
        const groupBaseUrl = new FormGroup2({ label: new LangTextV2({ text: 'Base URL' }) });
        groupBaseUrl.appendTo(body);
        this._inputBaseUrl = new Input2({ type: InputType2.text });
        this._inputBaseUrl.appendTo(groupBaseUrl);
        this._inputBaseUrl.setPlaceholder('https://fareharbor.com/api/v1');
        this._inputBaseUrl.setValue('https://fareharbor.com/api/v1');
        const groupShortname = new FormGroup2({ label: new LangTextV2({ text: 'Company shortname' }) });
        groupShortname.appendTo(body);
        this._inputCompanyShortname = new Input2({ type: InputType2.text });
        this._inputCompanyShortname.appendTo(groupShortname);
        this._inputCompanyShortname.setPlaceholder('whalewatching-gomera');
        const groupItemPks = new FormGroup2({ label: new LangTextV2({ text: 'Item ids (comma-separated; empty = all)' }) });
        groupItemPks.appendTo(body);
        this._inputItemPks = new Input2({ type: InputType2.text });
        this._inputItemPks.appendTo(groupItemPks);
        this._inputItemPks.setPlaceholder('326313, 326315');
        const groupEnabled = new FormGroup2({ label: new LangTextV2({ text: 'Enabled' }) });
        groupEnabled.appendTo(body);
        this._switchEnabled = new Switch2({});
        this._switchEnabled.appendTo(groupEnabled);
        this._switchEnabled.setEnable(true);
        this.addButtonClose(Lang.i().l('Close'));
        this.addButtonSave(Lang.i().l('Save'), true);
    }
    getSourceId() {
        return this._id;
    }
    setSourceId(id) {
        this._id = id;
    }
    resetValues() {
        this._id = null;
        this._selectOrganization.setSelectedValue('');
        this._selectProvider.setSelectedValue('fareharbor');
        this._inputBaseUrl.setValue('https://fareharbor.com/api/v1');
        this._inputCompanyShortname.setValue('');
        this._inputItemPks.setValue('');
        this._switchEnabled.setEnable(true);
    }
    setOrganizationList(list) {
        this._selectOrganization.clearValues();
        this._selectOrganization.setValues([
            { key: '', value: '— select organisation —' },
            ...list.map((o) => ({ key: `${o.id}`, value: o.description }))
        ]);
        this._selectOrganization.setSelectedValue('');
    }
    getOrganization() {
        return parseInt(this._selectOrganization.getSelectedValue() || '0', 10);
    }
    setOrganization(id) {
        this._selectOrganization.setSelectedValue(`${id}`);
    }
    getProvider() {
        return this._selectProvider.getSelectedValue() || 'fareharbor';
    }
    setProvider(provider) {
        this._selectProvider.setSelectedValue(provider || 'fareharbor');
    }
    getBaseUrl() {
        return this._inputBaseUrl.getValue().trim();
    }
    setBaseUrl(url) {
        this._inputBaseUrl.setValue(url);
    }
    getCompanyShortname() {
        return this._inputCompanyShortname.getValue().trim();
    }
    setCompanyShortname(name) {
        this._inputCompanyShortname.setValue(name);
    }
    getItemPks() {
        const raw = this._inputItemPks.getValue();
        return raw.split(',')
            .map((s) => s.trim())
            .filter((s) => s !== '');
    }
    setItemPks(pks) {
        this._inputItemPks.setValue(pks.join(', '));
    }
    getEnabled() {
        return this._switchEnabled.isEnable();
    }
    setEnabled(enabled) {
        this._switchEnabled.setEnable(enabled);
    }
}
